import { css } from "styled-components";

import { color } from "emoreg/const";

export const focusableInputStyle = css`
  appearance: none;
  &:focus-visible,
  &:focus,
  &:focus-within {
    outline: 2px solid ${color.blue.base};
  }
`;
